import { GiftReceiptRequestStatus } from "@redotech/redo-model/gift-receipt/gift-receipt-request";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const updateGiftReceiptRequestStatus = {
  name: "updateGiftReceiptRequestStatus" as const,
  input: z.object({
    id: zExt.objectId(),
    status: z.enum(Object.values(GiftReceiptRequestStatus)),
  }),

  output: z.object({ success: z.boolean() }),
};
